import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CircularProgress from '@mui/material/CircularProgress';
import translation from 'translation';
import { StyledLoading } from './Loading.styles';

const Loading = ({
  children,
  style = {},
  className = '',
  spinning = false,
  text,
  unVisibleText = false,
}) => {
  const { t } = translation;

  if (spinning)
    return (
      <StyledLoading className='loading-container'>
        <div
          style={{ minHeight: 30, ...style }}
          className={classNames('custom-loading', className)}
        >
          <CircularProgress
            sx={{
              color: '#199da3 !important',
            }}
            size={40}
          />
          {!unVisibleText && (
            <div className='loading-text'>
              {text || t('common:pleaseWaitAFewMoments')}
            </div>
          )}
          {children}
        </div>
      </StyledLoading>
    );
  return children || null;
};

Loading.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string,
  spinning: PropTypes.bool,
  unVisibleText: PropTypes.bool,
};

export default Loading;
